import { create } from 'zustand';
import { getNonLues, toutLire } from '../api/notifications';

const useNotifStore = create((set) => ({
    unread:        0,
    notifications: [],

    fetch: async () => {
        try {
            const { data } = await getNonLues();
            set({ unread: data.count, notifications: data.notifications });
        } catch {}
    },

    toutLire: async () => {
        await toutLire();
        set({ unread: 0 });
    },

    addNotif: (notif) =>
        set((state) => ({
            unread:        state.unread + 1,
            notifications: [notif, ...state.notifications],
        })),
}));

export default useNotifStore;